export const PROMOTER_TITLES = ["Party Promoter", "DJ", "Artist", "Influencer", "Dancer", "Bartender", "Other"];
